import { render } from "./UnsplashSearch.vue?vue&type=template&id=026fac03"
import script from "./UnsplashSearch.vue?vue&type=script&lang=js"
export * from "./UnsplashSearch.vue?vue&type=script&lang=js"

import "./UnsplashSearch.vue?vue&type=style&index=0&id=026fac03&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__